export default class DefaultReportAirport {
    "airportCode": string = "";
    "reportAirportCode": string = "";
} 